module.exports = __webpack_public_path__ + "img/news_head_2.e38e7dcd.jpg";